<ua-error [errorCode]="404"></ua-error>

<div class="text-center">
  <p class="mt-4">
    The link you clicked on has expired. Please log into your
    <a [routerLink]="['/account/reservations']" target="_blank">Account</a>
    to see your purchase.
  </p>
</div>
